/**
 * Destination-aware upload size cap for file-submission subtasks (Sondermind, bead new-main).
 *
 * Streamed destinations (Google Drive / OneDrive / SharePoint) upload direct-to-Firebase-Storage
 * and the backend STREAMS them to the destination (`createReadStream`), so they aren't bound by
 * any message-size limit → allow the larger cap. EMAIL delivery attaches the file to a Postmark
 * message whose TOTAL size cap is ~10MB (and base64 adds ~33%), so it keeps the conservative cap
 * — raising it there would trade a clear client-side reject for a silent Postmark send failure.
 * An unknown / unset destination is treated conservatively too.
 *
 * The three streamed values are the `SubmitTargetType` enum values (shared
 * deprecated/domainTypes/experience.ts: GOOGLE_DRIVE='GDRIVE', ONEDRIVE, SHAREPOINT). EMAIL is a
 * separate `{ type: 'EMAIL' }` submit-target variant, not part of that enum.
 */
export const MAX_UPLOAD_SIZE_MB_STREAMED = 20;
export const MAX_UPLOAD_SIZE_MB_DEFAULT = 10;

const STREAMED_SUBMIT_DESTINATIONS = ['GDRIVE', 'ONEDRIVE', 'SHAREPOINT'];

export const getMaxUploadSizeMb = (destinationType?: string | null): number =>
	destinationType != null && STREAMED_SUBMIT_DESTINATIONS.includes(destinationType)
		? MAX_UPLOAD_SIZE_MB_STREAMED
		: MAX_UPLOAD_SIZE_MB_DEFAULT;
